import { TemplateService } from '../../../services/template.service';
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import { ApiService } from '../../../services/api.service';
import { SubSink } from 'subsink';
import { HttpParams } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { CALENDAR_LOCALE } from '../../../services/constant';
import { AuthenticationService } from '../../../services/authentication.service';
var EmailDashboardOverdueComponent = (function () {
    function EmailDashboardOverdueComponent(apiService, template, authService, modalService) {
        this.apiService = apiService;
        this.template = template;
        this.authService = authService;
        this.modalService = modalService;
        this.subs = new SubSink();
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
        this.selectedValues = [];
        this.keepstartDate = null;
        this.keependDate = null;
        this.allZipCurrent = 0;
        this.canDownloadXml = false;
        this.loading = false;
        this.selectedBuyerTaxId = null;
        this.selectedDocumentId = null;
        this.selectedStatus = null;
        this.buyerTaxIdList = [];
        this.documentIdList = [];
        this.allBuyerTaxIdList = [];
        this.allDocumentIdList = [];
        this.startDate = null;
        this.endDate = null;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.loading_all_zip = false;
        this.cancel_loading_all_zip = false;
        this.loading_all_zip_message = '';
        this.loading_all_zip_progress = 0;
        this.tableArray = [];
        this.countOther = 0;
        this.countNonOther = 0;
        this.tableCol = [
            { field: 'tax_data__document_number', header: 'เลขที่เอกสาร' },
            { field: 'tax_data__header_issue_dt', header: 'วันที่ออกเอกสาร' },
            { field: 'created_at', header: 'วันที่ส่งอีเมลล์' },
            { field: 'tax_data__buyer_name', header: 'ชื่อผู้ซื้อ' },
            { field: 'tax_data__reference_ref_location', header: 'Location' },
            {
                field: 'additional_data.first_email_notified'
                    && 'additional_data.first_sms_notified', header: 'แจ้งเตือนครั้งที่ 1'
            },
            {
                field: 'additional_data.second_email_notified'
                    && 'additional_data.second_sms_notified', header: 'แจ้งเตือนครั้งที่ 2'
            },
            { field: 'tax_data__rd_document_type', header: 'ประเภทเอกสาร' },
            { field: 'status', header: 'สถานะ' },
            { field: 'receiver_email', header: 'อีเมลผู้รับ' },
        ];
    }
    EmailDashboardOverdueComponent.prototype.ngOnInit = function () {
        this.generateChart();
        this.loadTexts();
        this.rdDocumentType = this.template.getDropdown();
    };
    EmailDashboardOverdueComponent.prototype.generateChart = function () {
        var totalChart = this.transactions_success + this.transactions_failed + this.transactions_not_sent + this.transactions_manually_sent;
        this.successChart = new Chart('successChart', {
            type: 'doughnut',
            data: {
                datasets: [{
                        label: 'Success Chart',
                        data: [this.transactions_success, totalChart - this.transactions_success],
                        backgroundColor: [
                            '#30e9e9',
                            '#6F6E6E'
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed'
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
        this.failedChart = new Chart('failedChart', {
            type: 'doughnut',
            data: {
                datasets: [{
                        label: 'Failed Chart',
                        data: [this.transactions_failed, totalChart - this.transactions_failed],
                        backgroundColor: [
                            '#ff1f1a',
                            '#6F6E6E'
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed'
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
        this.notSentChart = new Chart('notSentChart', {
            type: 'doughnut',
            data: {
                datasets: [{
                        label: 'Not Sent Chart',
                        data: [this.transactions_not_sent, totalChart - this.transactions_not_sent],
                        backgroundColor: [
                            '#FFCD56',
                            '#6F6E6E'
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed'
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
        this.manuallySentChart = new Chart('manuallySentChart', {
            type: 'doughnut',
            data: {
                datasets: [
                    {
                        label: 'Manually Sent Chart',
                        data: [this.transactions_manually_sent, totalChart - this.transactions_manually_sent],
                        backgroundColor: [
                            '#ab72c0',
                            '#6F6E6E'
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed'
                        ],
                        borderWidth: 1
                    }
                ]
            },
            options: {
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
    };
    EmailDashboardOverdueComponent.prototype.pageChanged = function () {
        this.loadData();
        this.canDownloadXml = false;
    };
    EmailDashboardOverdueComponent.prototype.changeEmailReportStatus = function (taxDataArray, status) {
        var _this = this;
        var params = new HttpParams();
        params = params.append('tax_data_id_array', taxDataArray);
        params = params.append('status', status);
        this.apiService.updateEmailReportStatusOverdue(params).subscribe(function () {
            _this.loadTexts();
            _this.loadData();
            _this.sniff('UPDATE_REPORT', 'success');
        });
    };
    EmailDashboardOverdueComponent.prototype.changeEmailSelectedReportStatus = function () {
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i] || this.datastatus[i].status === 'success' || this.datastatus[i].status === 'manually_sent') {
                continue;
            }
            this.tableArray.push(this.datastatus[i].tax_data);
        }
        if (!_.isEmpty(this.tableArray)) {
            this.changeEmailReportStatus(this.tableArray, 'manually_sent');
        }
    };
    EmailDashboardOverdueComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    EmailDashboardOverdueComponent.prototype.searchButtonClicked = function () {
        this.loadData(true);
    };
    EmailDashboardOverdueComponent.prototype.clearData = function () {
        this.clearField();
        this.loadTexts();
    };
    EmailDashboardOverdueComponent.prototype.clearField = function () {
        this.transactions_failed = null;
        this.transactions_manually_sent = null;
        this.transactions_not_sent = null;
        this.transactions_success = null;
        this.datastatus = null;
        this.startDate = null;
        this.selectedBuyerTaxId = null;
        this.selectedDocumentId = null;
        this.selectedStatus = null;
        this.currentPage = 1;
        this.buyerTaxId = null;
        this.documentId = null;
        this.buyerTaxIdList = [];
        this.documentIdList = [];
        this.allBuyerTaxIdList = [];
        this.allDocumentIdList = [];
        this.startDate = null;
        this.endDate = null;
        this.totalItems = 0;
        this.emailTotal = 0;
        this.sortBy = null;
        this.sortMode = null;
        this.canDownloadXml = false;
        this.selectedValues = [];
    };
    EmailDashboardOverdueComponent.prototype.loadData = function (is_search) {
        var _this = this;
        if (is_search === void 0) { is_search = false; }
        this.datastatus = [];
        this.selectedValues = [];
        this.loading = true;
        var params = new HttpParams();
        if (this.selectedBuyerTaxId) {
            params = params.append('buyer_tax_id', this.selectedBuyerTaxId);
        }
        if (this.selectedDocumentId) {
            params = params.append('document_number', this.selectedDocumentId);
        }
        if (this.selectedRdDocumentType) {
            params = params.append('document_type', this.selectedRdDocumentType);
        }
        if (this.selectedStatus) {
            params = params.append('status', this.selectedStatus);
        }
        if (this.startDate) {
            this.keepstartDate = moment(this.startDate).format('YYYY-MM-DD');
            params = params.append('document_date_start', this.keepstartDate);
        }
        if (this.endDate) {
            this.keependDate = moment(this.endDate).format('YYYY-MM-DD');
            params = params.append('document_date_end', this.keependDate);
        }
        if (this.sortBy) {
            params = params.append('ordering', this.sortBy);
        }
        params = params.append('seller_tax_id', this.selectedCompany);
        params = params.append('page', _.toString(this.currentPage));
        params = params.append('page_size', _.toString(this.itemsPerPage));
        this.apiService.getEmailDashboardOverdue(params).subscribe(function (result) {
            _this.datastatus = result.results;
            _this.totalItems = result.count;
            _this.transactions_failed = result.transactions_failed;
            _this.transactions_success = result.transactions_success;
            _this.transactions_not_sent = result.transactions_not_sent;
            _this.transactions_manually_sent = result.transactions_manually_sent;
            _this.emailTotal = _this.transactions_success + _this.transactions_failed
                + _this.transactions_not_sent + _this.transactions_manually_sent;
            if (is_search === true) {
                _this.generateChart();
            }
            _this.loading = false;
            _this.sniff('GET_EMAIL_DASHBOARD_OVERDUE', '');
        });
    };
    EmailDashboardOverdueComponent.prototype.getEmailDashboardOverdue = function () {
        var _this = this;
        var params = new HttpParams();
        if (this.selectedCompany) {
            params = params.append('seller_tax_id', this.selectedCompany);
        }
        this.apiService.getEmailDashboardOverdue(params).subscribe(function (result) {
            _this.transactions_success = result.transactions_success;
            _this.transactions_failed = result.transactions_failed;
            _this.transactions_not_sent = result.transactions_not_sent;
            _this.transactions_manually_sent = result.transactions_manually_sent;
            _this.emailTotal = _this.transactions_success + _this.transactions_failed
                + _this.transactions_not_sent + _this.transactions_manually_sent;
            _this.generateChart();
            _.forEach(result.results, function (obj) {
                _this.buyerTaxId.push({
                    label: obj.buyer_tax_id,
                    value: obj.buyer_tax_id
                });
                _this.buyerTaxIdList.push({
                    label: obj.buyer_tax_id,
                    value: obj.buyer_tax_id
                });
                _this.documentId.push({
                    label: obj.document_number,
                    value: obj.document_number
                });
                _this.documentIdList.push({
                    label: obj.document_number,
                    value: obj.document_number
                });
            });
            _this.sniff('GET_EMAIL_DASHBOARD_OVERDUE', '');
        }, function (error) { return error(status); });
    };
    EmailDashboardOverdueComponent.prototype.loadTexts = function () {
        var _this = this;
        this.selectedBuyerTaxId = null;
        this.selectedDocumentId = null;
        this.buyerTaxId = null;
        this.documentId = null;
        this.selectedRdDocumentType = null;
        this.buyerTaxId = [{
                label: 'ทั้งหมด',
                value: null
            }];
        this.documentId = [{
                label: 'ทั้งหมด',
                value: null
            }];
        this.companyList = [{
                label: 'ทั้งหมด',
                value: ''
            }];
        this.selectedCompany = '';
        this.apiService.getCompany().subscribe(function (results) {
            _.forEach(results, function (obj) {
                _this.companyList.push({
                    label: obj.name,
                    value: obj.tax_id
                });
            });
            if (_this.companyList.length === 2) {
                _this.selectedCompany = _this.companyList[1].value;
                _this.companyList.splice(0, 1);
            }
            else {
                _this.selectedCompany = _this.companyList[0].value;
            }
            _this.getEmailDashboardOverdue();
        });
    };
    EmailDashboardOverdueComponent.prototype.filterDocumentIdList = function () {
        var _this = this;
        // this.selectedDocumentId = null;
        this.documentIdList = [{
                label: 'ทั้งหมด',
                value: null
            }];
        _.forEach(this.allDocumentIdList, function (obj) {
            if (_this.selectedDocumentId == null || obj.value === _this.selectedDocumentId) {
                _this.documentIdList.push({
                    label: obj.label,
                    value: obj.value
                });
            }
        });
    };
    EmailDashboardOverdueComponent.prototype.filterBuyerTaxIdList = function () {
        var _this = this;
        // this.selectedBuyerTaxId = null;
        this.buyerTaxIdList = [{
                label: 'ทั้งหมด',
                value: null
            }];
        _.forEach(this.allBuyerTaxIdList, function (obj) {
            if (_this.selectedBuyerTaxId == null || obj.value === _this.selectedBuyerTaxId) {
                _this.buyerTaxIdList.push({
                    label: obj.label,
                    value: obj.value
                });
            }
        });
    };
    EmailDashboardOverdueComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    EmailDashboardOverdueComponent.prototype.selectedType = function (type, status) {
        if (this.selectedStatus === status) {
            this.selectedStatus = null;
        }
        else {
            this.selectedStatus = status;
        }
        this.currentPage = 1;
        this.loadData();
    };
    Object.defineProperty(EmailDashboardOverdueComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = new Date().getFullYear();
            return thisYear - 40 + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailDashboardOverdueComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    EmailDashboardOverdueComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    EmailDashboardOverdueComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    EmailDashboardOverdueComponent.prototype.selectIn = function (checker, data) {
        if (data.document_type !== 'other' && checker === true) {
            this.canDownloadXml = this.selectedValues.filter(function (select) { return select === true; }).length > 0;
            this.countNonOther++;
            if (this.countNonOther > 0) {
                this.canDownloadXml = true;
            }
        }
        if (data.document_type !== 'other' && checker === false) {
            this.canDownloadXml = (data.document_type !== 'other' && this.selectedValues.filter(function (select) { return select === true; }).length !== 0);
            this.countNonOther--;
            if (this.countNonOther === 0) {
                this.canDownloadXml = false;
            }
        }
    };
    EmailDashboardOverdueComponent.prototype.selectDeselectAll = function (checked) {
        if (checked) {
            this.selectAll();
            return;
        }
        this.deselectAll();
    };
    EmailDashboardOverdueComponent.prototype.selectAll = function () {
        var _this = this;
        for (var i = 0; i < this.datastatus.length; i++) {
            if (this.datastatus[i].doc_status === 'active' && this.datastatus[i].status !== 'success') {
                this.canDownloadXml = this.selectedValues[i] = true;
            }
        }
        this.countOther = 0;
        this.countNonOther = 0;
        this.datastatus.forEach(function (obj) {
            if (obj.document_type === 'other') {
                _this.countOther++;
            }
            else {
                _this.countNonOther++;
            }
        });
    };
    EmailDashboardOverdueComponent.prototype.deselectAll = function () {
        for (var i = 0; i < this.datastatus.length; i++) {
            this.canDownloadXml = this.selectedValues[i] = false;
        }
        this.countOther = 0;
        this.countNonOther = 0;
    };
    EmailDashboardOverdueComponent.prototype.DownloadSelected = function (content, doc_type) {
        this.tableArray = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i] || this.datastatus[i].doc_status === 'cancelled') {
                continue;
            }
            // skip if rd_document_type is `other`
            if (this.datastatus[i].document_type === 'other' && doc_type === 'xml') {
                continue;
            }
            this.tableArray.push(this.datastatus[i]);
        }
        if (!_.isEmpty(this.tableArray)) {
            this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
            this.allZipCount = this.tableArray.length;
            this.cancel_loading_all_zip = false;
            if (doc_type === 'xml') {
                this.download(0, this.tableArray, 'xml_file');
            }
            else {
                this.download(0, this.tableArray, 'pdf_file');
            }
        }
    };
    EmailDashboardOverdueComponent.prototype.download = function (index, tableArray, url_field_name) {
        var _this = this;
        this.loading_all_zip = true;
        if (index >= tableArray.length) {
            this.loading_all_zip = false;
            this.loading_all_zip_message =
                'Download เสร็จสมบูรณ์ (ทั้งหมด ' + tableArray.length + ' รายการ)';
            return;
        }
        if (this.cancel_loading_all_zip) {
            return;
        }
        var download_url = tableArray[index][url_field_name];
        // skip if download url is empty.
        if (download_url == null || download_url.length === 0) {
            this.download(index + 1, tableArray, url_field_name);
            return;
        }
        this.subs.add(this.apiService.downloadFileFromMediaPath(download_url).subscribe(function (obj) {
            if (_this.cancel_loading_all_zip) {
                return;
            }
            // this.loading_all_zip = false;
            var filename = _this.getFileName(tableArray[index]);
            if (url_field_name === 'xml_file') {
                filename = filename + '.xml';
            }
            else {
                filename = filename + '.pdf';
            }
            _this.apiService.createDownloadFile(obj, filename);
            _this.allZipCurrent++;
            _this.loading_all_zip_progress = (_this.allZipCurrent / _this.allZipCount) * 100;
            // data.xmlLoading = false;
            setTimeout(function () {
                _this.download(index + 1, tableArray, url_field_name);
            }, 1000);
        }, function (error) {
            _this.loading_all_zip = false;
            _this.loading_all_zip_message = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
            // data.xmlLoading = false;
        }));
    };
    EmailDashboardOverdueComponent.prototype.getFileName = function (data) {
        var file_name = '' + data.document_number + '_' + data.document_type + '_' + data.document_date;
        file_name = file_name.replace(/([^a-z0-9]+)/gi, '_');
        return file_name;
    };
    EmailDashboardOverdueComponent.prototype.sort = function (event) {
        if (event.order === '1') {
            this.sortBy = event.field;
            this.sortMode = 'asc';
        }
        else {
            this.sortBy = '-' + event.field;
            this.sortMode = 'desc';
        }
    };
    EmailDashboardOverdueComponent.prototype.canDownloadPdf = function () {
        return this.selectedValues.filter(function (select) { return select === true; }).length > 0;
    };
    EmailDashboardOverdueComponent.prototype.closeDownloadAll = function () {
        this.modal.close();
        this.cancel_loading_all_zip = true;
        this.loading_all_zip = false;
        this.allZipCurrent = 0;
        this.loading_all_zip_progress = 0;
    };
    EmailDashboardOverdueComponent.prototype.isExist = function (data) {
        return data != null && data !== '' && data !== '' && data !== undefined;
    };
    EmailDashboardOverdueComponent.prototype.createDownloadFile = function (blob, filename) {
        // for IE10+
        if (typeof navigator !== 'undefined' && navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        }
        else {
            var element = document.createElement('a');
            document.body.appendChild(element);
            var url = window.URL.createObjectURL(blob);
            element.setAttribute('href', url);
            element.setAttribute('download', filename);
            element.style.display = 'none';
            element.click();
            document.body.removeChild(element);
        }
    };
    EmailDashboardOverdueComponent.prototype.downloadExcel = function () {
        var _this = this;
        this.selectedValues = [];
        var params = new HttpParams();
        if (this.selectedBuyerTaxId) {
            params = params.append('buyer_tax_id', this.selectedBuyerTaxId);
        }
        if (this.selectedDocumentId) {
            params = params.append('document_number', this.selectedDocumentId);
        }
        if (this.selectedRdDocumentType) {
            params = params.append('document_type', this.selectedRdDocumentType);
        }
        if (this.selectedStatus) {
            params = params.append('status', this.selectedStatus);
        }
        if (this.startDate) {
            this.keepstartDate = moment(this.startDate).format('YYYY-MM-DD');
            params = params.append('document_date_start', this.keepstartDate);
        }
        if (this.endDate) {
            this.keependDate = moment(this.endDate).format('YYYY-MM-DD');
            params = params.append('document_date_end', this.keependDate);
        }
        if (this.sortBy) {
            params = params.append('ordering', this.sortBy);
        }
        params = params.append('page', _.toString(this.currentPage));
        params = params.append('page_size', _.toString(this.itemsPerPage));
        this.apiService.getExcelEmailDashboardOverdue(params).subscribe(function (result) {
            var filename = 'Email_Dashboard_Notification.xlsx';
            _this.createDownloadFile(result, filename);
            _this.sniff('DOWNLOAD_EXCEL', filename);
        });
    };
    EmailDashboardOverdueComponent.prototype.isViewer = function () {
        return this.authService.isViewer();
    };
    EmailDashboardOverdueComponent.prototype.isViewerAudit = function () {
        return this.authService.isViewerAudit();
    };
    EmailDashboardOverdueComponent.prototype.sniff = function (action, detail) {
        var data = {
            action: action,
            feature: 'EMAIL_DASHBOARD_OVERDUE',
            detail: detail
        };
        this.apiService.sniff(data).subscribe();
    };
    return EmailDashboardOverdueComponent;
}());
export { EmailDashboardOverdueComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard-overdue/email-dashboard-overdue/email-dashboard-overdue.component.ts.pre-build-optimizer.js